export enum PlaceBidStatus {
  Biddable = 'biddable',
  NotBiddable = 'not-biddable',
  Placed = 'placed',
  PlaceFailed = 'place-failed',
}
